import React, { FC } from 'react';
import { Text, Heading, Link, Button } from 'roo-ui/components';

export interface RequestCallbackConfirmationProps {
  onClose: Function;
}

export const RequestCallbackConfirmation: FC<RequestCallbackConfirmationProps> =
  ({ onClose }) => (
    <>
      <Heading.h3 fontSize="xl" mb={6}>
        Thank you for your interest
      </Heading.h3>

      <Text
        display="block"
        fontSize="base"
        mb={5}
        data-testid="call-center-number"
      >
        One of our customer service representatives will be in touch shortly. If
        you have any questions please call&nbsp;
        <Link href="tel:137066">13 70 66</Link>.
      </Text>

      <Button
        variant="primary"
        width={['100%', '220px']}
        onClick={() => onClose()}
        data-testid="close-confirmation"
      >
        Close
      </Button>
    </>
  );
